import { Spinner } from "@chakra-ui/react";
import { EhrName } from "@metriport/shared-internal";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PatientMapping } from "../../api/ehr";
import useMetriportToast from "../shared/toast";
import { useCxMappingQuery } from "../shared/use-cx-mapping";
import { ehrIdFromMappingSource, EHR_LIST } from "./ehr-config";
import EhrSearch from "./EhrSearchPage";
import ElationSection from "./elation/ElationSection";
import HealthieSection from "./healthie/HealthieSection";
import EhrBasePage from "./shared/EhrBasePage";

export default function EhrDetailPage() {
  const { cxId, ehrName } = useParams<{ cxId: string; ehrName: string }>();
  const navigate = useNavigate();
  const toast = useMetriportToast();
  const ehr = EHR_LIST.find(e => e.id === ehrName);
  const [patientMapping, setPatientMapping] = useState<PatientMapping | undefined>();

  const cxMappingQuery = useCxMappingQuery(cxId);

  const cxMapping = cxMappingQuery.data?.find(m => ehrIdFromMappingSource(m.source) === ehr?.id);

  useEffect(() => {
    if (cxId && !cxMappingQuery.isLoading && !cxMapping) {
      toast.error({ title: `No ${ehrName} EHR integration found for this customer.` });
      navigate(`/ehr/${encodeURIComponent(cxId)}`);
    }
  }, [cxMapping, cxMappingQuery.isLoading, cxId]);

  if (cxMappingQuery.isLoading) {
    return <Spinner />;
  }

  if (!cxId || !ehr) {
    return <EhrSearch />;
  }

  return (
    <EhrBasePage
      ehrId={ehr.id}
      ehrName={ehr.name}
      cxId={cxId}
      setPatientMapping={setPatientMapping}
    >
      {renderEhrSection({ ehr: ehr.name, patientMapping, cxId })}
    </EhrBasePage>
  );
}

function renderEhrSection({
  ehr,
  patientMapping,
  cxId,
}: {
  ehr: EhrName;
  patientMapping: PatientMapping | undefined;
  cxId: string;
}) {
  switch (ehr) {
    case EhrName.Healthie:
      return <HealthieSection patientMapping={patientMapping} cxId={cxId} />;
    case EhrName.Elation:
      return <ElationSection patientMapping={patientMapping} cxId={cxId} />;
    default:
      return null;
  }
}
